<script setup lang="ts">
defineProps<{
  title?: string
}>()
</script>
<template>
  <BaseCard class="p-8">
    <BaseHeading
      v-if="title"
      size="xs"
      as="h4"
      class="mb-6 uppercase"
    >
      {{ title }}
    </BaseHeading>
    <div class="text-sm">
      <slot />
    </div>
  </BaseCard>
</template>
